// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"9180f212","312":"78095030","453":"1f1c5e01"}[chunkId] + ".chunk.js";
};